
[
  {
    "id": "TG-B8P-L302-001",
    "module": "TijdGeld",
    "difficulty": 302,
    "question": "Samengestelde interest: € 1000, 10% rente, 2 jaar. Hoeveel rente in euro's?",
    "options": ["€ 210", "€ 200", "€ 220", "€ 100"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "rente",
    "familyId": "TG-RENTE-SAMEN",
    "explanation": "Jaar 1: 100 rente (totaal 1100). Jaar 2: 10% van 1100 = 110. Totaal rente: 100 + 110 = 210.",
    "distractorExplanations": { "1": "Enkelvoudige rente.", "2": "Rekenfout.", "3": "1 jaar." }
  },
  {
    "id": "TG-B8P-L302-002",
    "module": "TijdGeld",
    "difficulty": 302,
    "question": "Hoeveel seconden is 1 micro-eeuw? (1 eeuw = 100 jaar, schatting)",
    "options": ["52 minuten", "1 uur", "10 minuten", "1 dag"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-MICRO-EEUW",
    "explanation": "100 jaar x 365 dagen x 24 uur x 60 min = 52.560.000 min. Micro is miljoenste. Dus ongeveer 52 minuten.",
    "distractorExplanations": { "1": "Schattingsfout.", "2": "Schattingsfout.", "3": "Schattingsfout." }
  },
  {
    "id": "TG-B8P-L302-003",
    "module": "TijdGeld",
    "difficulty": 302,
    "question": "Valuta: 1 EUR = 0,85 GBP. Hoeveel pond krijg je voor 200 euro?",
    "options": ["170 GBP", "235 GBP", "185 GBP", "160 GBP"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "valuta",
    "familyId": "TG-VALUTA-GBP",
    "explanation": "200 x 0,85 = 170.",
    "distractorExplanations": { "1": "Gedeeld door 0,85.", "2": "Rekenfout.", "3": "Rekenfout." }
  },
  {
    "id": "TG-B8P-L302-004",
    "module": "TijdGeld",
    "difficulty": 302,
    "question": "Een lening van € 10.000 moet in 5 jaar worden afgelost met 5% rente per jaar over het oorspronkelijke bedrag. Wat is het maandbedrag?",
    "options": ["€ 208,33", "€ 166,67", "€ 200,00", "€ 250,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "rente",
    "familyId": "TG-LENING",
    "explanation": "Aflossing: 10.000 : 60 mnd = 166,67. Rente: 500/jr = 41,67/mnd. Totaal 208,33.",
    "distractorExplanations": { "1": "Alleen aflossing.", "2": "Alleen aflossing + afronding.", "3": "Schattingsfout." }
  },
  {
    "id": "TG-B8P-L302-005",
    "module": "TijdGeld",
    "difficulty": 302,
    "question": "Hoeveel dagen zit er tussen 1 januari en 1 april in een schrikkeljaar?",
    "options": ["91", "90", "92", "89"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kalender",
    "subSkill": "kalender_schrikkel",
    "familyId": "TG-DAGEN-SCHRIKKEL",
    "explanation": "Jan (31) + Feb (29) + Mrt (31) = 91.",
    "distractorExplanations": { "1": "Gewoon jaar.", "2": "Te veel.", "3": "Te weinig." }
  }
]
